/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { KTSVG } from "../../../helpers";
import { AsideMenuItemWithSub } from "./AsideMenuItemWithSub";
import { AsideMenuItem } from "./AsideMenuItem";
import { useSelector, shallowEqual } from "react-redux";
import { RootState } from "../../../../setup/redux/RootReducer";
import { isObject } from "../../../../app/utility/common-validation";

export function AsideMenuMain() {
  const intl = useIntl();

  const user: any = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  );

  const loginUserInfo =
    isObject(user?.data) && isObject(user.data.role) ? user.data.role : {};

  return (
    <>
      <div style={{ marginBottom: "60px" }}>
        {" "}
        {/* dashboard  */}
        <AsideMenuItem
          to="/dashboard"
          icon="/media/icons/duotune/sidebarIcon/dashboard.svg"
          title={intl.formatMessage({ id: "MENU.DASHBOARD" })}
          fontIcon="bi-app-indicator"
        />
        {/* crop menu start */}
        {loginUserInfo.role_id === 1 && (
          <AsideMenuItemWithSub
            to=""
            title="User"
            fontIcon="bi-archive"
            icon="/media/icons/duotune/sidebarIcon/user.svg"
          >
            <AsideMenuItem
              to="/pending-user"
              title="Pending User"
              hasBullet={true}
            />
            <AsideMenuItem to="/admin" title="Admin" hasBullet={true} />
            <AsideMenuItem to="/employee" title="Employee" hasBullet={true} />
          </AsideMenuItemWithSub>
        )}
        {/* // */}
        <AsideMenuItem
          to="/designation"
          icon="/media/icons/duotune/sidebarIcon/designation.svg"
          title="Designation"
          fontIcon="bi-layers"
        />
        {/* // */}
        <AsideMenuItem
          to="/department"
          icon="/media/icons/duotune/sidebarIcon/department.svg"
          title="Department"
          fontIcon="bi-layers"
        />
        {/* // */}
        <AsideMenuItem
          to="/crop"
          icon="/media/icons/duotune/sidebarIcon/crop.svg"
          title="Crop"
          fontIcon="bi-layers"
        />
        {/* // */}
        <AsideMenuItem
          to="/disease"
          icon="/media/icons/duotune/sidebarIcon/disease.svg"
          title="Disease"
          fontIcon="bi-layers"
        />
        {/* // */}
        <AsideMenuItem
          to="/season"
          icon="/media/icons/duotune/sidebarIcon/season.svg"
          title="Season"
          fontIcon="bi-layers"
        />
        {/* // */}
        <AsideMenuItemWithSub
          to=""
          title="Experiment"
          fontIcon="bi-archive"
          icon="/media/icons/duotune/sidebarIcon/experiment.svg"
        >
          <AsideMenuItem
            to="/running-experiment"
            title="Running Experiment"
            hasBullet={true}
          />
          <AsideMenuItem
            to="/experiment-request"
            title="Experiment Request"
            hasBullet={true}
          />
        </AsideMenuItemWithSub>
        {/* <AsideMenuItem
          to="/setting"
          icon="/media/icons/duotune/sidebarIcon/setting.svg"
          title="Settings"
          fontIcon="bi-layers"
        /> */}
        {/* <AsideMenuItem to="/my-page" title="My Page" />*/}
      </div>
    </>
  );
}
